import { RootState } from '../../store';

export const getIdToDeleteSelector = (state: RootState) => state?.streetReducer?.streetIdToDelete;
